/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAdressBrandTechnicalSupportResponsibleApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAdressBrandTechnicalSupportResponsible: builder.query({
            query: ({ addressBrandId, pageNumber = 1, pageSize = 10 }) => ({
                url: 'v1/dealeraddressbrandtechsupresponsible/getlist',
                method: 'POST',
                body: {
                    addressBrandId,
                    pageNumber,
                    pageSize
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return { items: [], count: 0 };
            },
            providesTags: ['DealerAdressBrandTechnicalSupportResponsible']
        }),

        getByIdDealerAdressBrandTechnicalSupportResponsible: builder.query({
            query: (id) => ({
                url: 'v1/dealeraddressbrandtechsupresponsible/getbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAdressBrandTechnicalSupportResponsible', id }]
        }),

        createDealerAdressBrandTechnicalSupportResponsible: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandtechsupresponsible/add',
                method: 'POST',
                body: {
                    ...data,
                    CreatedSession: 'web'
                }
            }),
            invalidatesTags: (result, error, arg) => ['DealerAdressBrandTechnicalSupportResponsible', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        updateDealerAdressBrandTechnicalSupportResponsible: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandtechsupresponsible/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAdressBrandTechnicalSupportResponsible', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        deleteDealerAdressBrandTechnicalSupportResponsible: builder.mutation({
            // Hem sayısal id hem { id, dealerAddressBrandId } kabul edilir (id request'e gider,
            // dealerAddressBrandId yalnızca hedefli cache invalidation için kullanılır).
            query: (arg) => {
                const id = arg && typeof arg === 'object' ? arg.id : arg;
                return {
                    url: 'v1/dealeraddressbrandtechsupresponsible/delete',
                    method: 'DELETE',
                    params: { id }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAdressBrandTechnicalSupportResponsible', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        })
    })
});

export const {
    useGetAllDealerAdressBrandTechnicalSupportResponsibleQuery,
    useGetByIdDealerAdressBrandTechnicalSupportResponsibleQuery,
    useCreateDealerAdressBrandTechnicalSupportResponsibleMutation,
    useUpdateDealerAdressBrandTechnicalSupportResponsibleMutation,
    useDeleteDealerAdressBrandTechnicalSupportResponsibleMutation
} = dealerAdressBrandTechnicalSupportResponsibleApi;

